import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import React, {useState} from 'react'
import {IApplications, applicationsInitValues as initialValues} from '../../models/ApplicationModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import {useIntl} from 'react-intl'
import {Input3} from '../../../../../../components/Forms/Input'
import AsyncSelect from 'react-select/async'
import {colourStyles} from '../../../../../../util/styles/styles'
import {PageTitle} from '../../../../../../_metronic/layout/core'
import {Toolbar2} from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'

const API_URL = process.env.REACT_APP_API_URL || 'api'

const ApplicationsSchema = Yup.object().shape({
  title: Yup.string().required('Campo obrigatório'),
  description: Yup.string().required('Campo obrigatório'),
  url: Yup.string().required('Campo obrigatório'),
  order: Yup.string().required('Campo obrigatório'),
  projects: Yup.array().min(1, 'Campo Obrigatório'),
})

const FormApplicationsAdd: React.FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  // const resp = localStorage.getItem('auth_storage')
  const [projects, setProjects] = useState()

  interface UseOption {
    readonly value: string
    readonly label: string
  }

  const data = new FormData()

  //função de load do select2 de Projetos -- project_id
  const loadOptionsProjects = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getProjects()
      var projects: any = []
      // var options: any = []

      async function getProjects() {
        const {data} = await axios.get(API_URL + '/v1/projects/select2')
        let Response = data.results

        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const project: any = {
              value: Response[i].id,
              label: `${Response[i].code} - ${Response[i].description}`,
            }
            projects.push(project)
          }
        }
      }
      callback(projects)
    }, 500)
  }

  const formik = useFormik<IApplications>({
    initialValues,
    validationSchema: ApplicationsSchema,
    onSubmit: async (values) => {
      setLoading(true)
      console.log(values, 'values aqui')

      try {
        data.append('title', values.title)
        data.append('description', values.description)
        data.append('url', values.url)
        if (values.order) data.append('order', values.order.toString())
        //ENVIAR ARRAY COM IDS
        if (values.projects) {
          for (const element of values.projects) {
            let convert: any = element
            data.append('project_id[]', convert)
            console.log(convert, 'convert')
          }
        }
        if (values.path) data.set('path', values.path as File)

        await axios({
          method: 'post',
          url: API_URL + '/v1/applications',
          data: data,
          headers: {'Content-Type': 'multipart/form-data'},
        })
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'APPLICATIONS.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/applications')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'APPLICATIONS.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 2000,
        })

        setLoading(false)
      }
    },
  })

  const handleInputChangeProjects = (event: any) => {
    var inputValue = []
    if (event) {
      for (var i = 0; i < event.length; i++) {
        inputValue.push(event[i].value)
      }
    }
    setProjects(event)
    formik.setFieldValue('projects', inputValue)
    return {inputValue}
  }

  function resetInputs() {
    formik.resetForm()
  }

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    formik.setFieldValue('path', event.target.files![0])
  }

  return (
    <div className='card card-custom mt-n8'>
      {/* Component Header de Cadastros. */}
      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'APPLICATIONS.NEW_APPLICATION'})}</PageTitle>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            
            <div className='row mb-3'>
            {/* INICIO TITLE */}
              <div className='col-lg-6'>
                <Input3
                  title={intl.formatMessage({id: 'APPLICATIONS.TABLE_TITLE'})}
                  placeholder={intl.formatMessage({id: 'APPLICATIONS.TITLE_PLACEHOLDER'})}
                  {...formik.getFieldProps('title')}
                  required
                />
              </div>
              {/* FIM TITLE */}

              {/* INÍCIO URL */}
                <div className='col-lg-6'>
                  <Input3
                    title={intl.formatMessage({id: 'APPLICATIONS.TABLE_URL'})}
                    placeholder={intl.formatMessage({id: 'APPLICATIONS.URL_PLACEHOLDER'})}
                    {...formik.getFieldProps('url')}
                    required
                  />
                </div>
              {/* FIM URL */}
            </div>

            <div className='row mb-3'>
              {/* INÍCIO DESCRIPTION */}
              <div className='col-lg-6'>
                <Input3
                  title={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                  placeholder={intl.formatMessage({id: 'COMMON.PLACEHOLDER_INPUT_DESCRIPTION'})}
                  {...formik.getFieldProps('description')}
                />
              </div>
              {/* FIM DESCRIPTION */}

              {/* INÍCIO ORDEM */}
              <div className='col-lg-6'>
                <Input3
                  title={intl.formatMessage({id: 'PROPERTY_REGISTRIES.ORDER'})}
                  placeholder={intl.formatMessage({id: 'APPLICATIONS.ORDER_PLACEHOLDER'})}
                  {...formik.getFieldProps('order')}
                  required
                />
              </div>
              {/* FIM ORDEM */}
            </div>

            {/* INÍCIO PROJETO */}
            <div className='row mb-3'>
              <label className='form-label fw-bold required'>
                {intl.formatMessage({id: 'PROJECT.PROJECT_PLURAL'})}
              </label>

              <div className='col-lg-12'>
                <div className='row'>
                  <div className='col-lg-12 fv-row'>
                    <AsyncSelect
                      className='form-control form-control-sm form-control-solid p-0 ps-3'
                      data-kt-license-table-filter='projects'
                      styles={colourStyles}
                      cacheOptions
                      isMulti
                      loadOptions={loadOptionsProjects}
                      filterOption={(option, inputValue) =>
                        option.label
                          ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                          : false
                      }
                      defaultOptions
                      placeholder={intl.formatMessage({id: 'PROJECT.PROJECT_PLURAL'})}
                      onChange={handleInputChangeProjects}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* FIM PROJETO */}

            {/* INICIO PATH */}

            <div className='mt-3'>
              <label className='form-label fw-bold '>
                {intl.formatMessage({id: 'APPLICATIONS.IMAGE'})}
              </label>
              <input className='form-control form-control-sm' type='file' onChange={onChange} />
            </div>

            {/* FIM PATH */}

            <div className='d-flex justify-content-end pt-6'>
              <button type='submit' className='btn btn-sm btn-primary' disabled={loading}>
                {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <button type='reset' onClick={resetInputs} className='btn btn-sm btn-secondary  mx-2'>
                {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {FormApplicationsAdd}
